<template lang="pug">
  .table-responsive
    table#tbConsumibles.table.is-striped.is-fullwidth
      thead
        tr
          th Descripción
          th Ubicación
          th Área
          th Fecha Pro.
          th Estado
          th Observaciones
      tbody
        tr(v-for="(data, index) in actividades" :key="data.id")
          td
            | {{ data.descripcion }}
          td
            | {{ data.ubicacion }}
          td
            span.tag(:class="getClassArea(data.area)") 
              | {{ convertirArea(data.area) }}
          td
            span.tag
              | {{ convetirPeriodo(data.fechaInicio, data.fechaFin)}}
          td
            span.tag(:class="getClassEstado(data.estado)") 
              | {{ convetirEstado(data.estado) }}
          td {{ data.observaciones }}
</template>

<script>
  import moment from 'moment' 

  export default {
    name: 'TbActivades',
    props: {
      actividades: {
        type: Array,
        default: []
      },
    },
    methods: {
      convetirEstado (estado) {
        switch (estado) {
          case '5':
            return 'Programada'
            break
          case '0':
            return 'Abierta'
            break
          case '1':
            return 'En Revisión'
            break
          case '2':
            return 'Finalizda'
            break
          case '6':
            return 'Reprogramada'
            break
        
          default:
            break
        }
      },
      getClassArea (a) {
        let clase = ''
        if (a === '1') {
          clase = 'is-black'
        } else {
          clase = 'is-primary'
        }

        return clase
      },
      getClassEstado (est) {
        let clase = ''
        switch (est) {
          case '0':
            clase = 'is-danger'
            break
          case '1':
            clase = 'is-warning'
            break
          case '2':
            clase = 'is-success'
            break
          case '5':
            clase = 'is-black'
            break
          case '6':
            clase = 'is-info'
            break
        
          default:
            clase = 'is-danger'
            break
        }

        return clase
      },
      convetirPeriodo (fechaI, fechaF) {
        moment.locale('es')
        let dI = fechaI.substring(8, 10)
        let dF = fechaF.substring(8, 10)
        let anio = fechaF.substring(0, 4)
        let mesNombre = moment(fechaI).format('MMMM')
        
        return `${dI}-${dF} de ${mesNombre} de ${anio}`
      },
      convertirArea (area) {
        switch (area) {
          case '1':
            return 'Inst. y Control'
            break
          case '3':
            return 'Sist. y Telec.'
            break
          default:
            break
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/planificacion_Componentes/TbActividades.vue